import ellipsize from "ellipsize";
import latinize from "latinize";
import { extend } from "lodash-es";
import { stripHtml } from "string-strip-html";
// modify the behavior for German umlauts
// noinspection NonAsciiCharacters
extend(latinize.characters, {
    Ä: "Ae",
    Ö: "Oe",
    Ü: "Ue",
    ä: "ae",
    ö: "oe",
    ü: "ue",
});
export const stripHtmlTags = (html = "", keepLineBreaks = true) => {
    return stripHtml(keepLineBreaks
        ? html
            .replace(/<br ?\/?>/gi, `<br/>\n`)
            .replace(/<\/(br|p|li|h1|h2|h3|h4|h5|h6)>/gi, `</$1>\n`)
        : html).result;
};
export const nl2br = (text) => text.replace(/\r\n|\r|\n/g, "<br/>");
export const truncateText = (text, maxSymbolsAmount) => ellipsize(text, maxSymbolsAmount);
// Trimmed, with a blank or absent value collapsed to null — the canonical
// stored form of an offered-service smart-process override.
export const normalizeSmartProcess = (value) => {
    const trimmed = value?.trim();
    return trimmed === undefined || trimmed === "" ? null : trimmed;
};
export function getFileName(name, spacer = "-") {
    return latinize(name)
        .replace(/[^0-9a-zA-Z ]/gi, "")
        .replace(/\s+/gi, spacer);
}
/**
 * RFC 6266 header value with an RFC 5987 `filename*` for browsers and an ASCII
 * `filename` for clients that ignore it.
 */
export function buildContentDisposition({ type, filename, }) {
    const clean = filename.replace(/\p{Cc}/gu, "").trim();
    const ascii = latinize(clean)
        .replace(/[^\x20-\x7e]/g, "_")
        .replace(/["\\]/g, "");
    const encoded = encodeURIComponent(clean).replace(/['()*]/g, char => `%${char.charCodeAt(0).toString(16).toUpperCase()}`);
    return `${type}; filename="${ascii}"; filename*=UTF-8''${encoded}`;
}
//# sourceMappingURL=text.js.map